"use client";
import React, { Suspense, useEffect } from "react";
import ReactQueryClientProvider from "@/shared/lib/providers/ReactQueryProvider";
import {
  setFirmMap,
  setFirmsData,
  setDetectedDomain,
} from "@/shared/lib/utils/firm";
import { initPendo } from "@/shared/components/pendo";
import { Toaster } from "@/shared/components/ui/sonner";
import { ImpersonationProvider } from "@/shared/impersonation";

export default function ClientLayout({
  children,
  firmId,
  firmMap,
  firmsData,
  detectedDomain,
}: {
  children: React.ReactNode;
  firmId: string | null;
  firmMap: Record<string, any>;
  firmsData: any[];
  detectedDomain?: string | null;
}) {
  useEffect(() => {}, [firmId, firmMap, firmsData, detectedDomain]);

  useEffect(() => {
    initPendo();
  }, []);

  useEffect(() => {
    if (firmId) {
      sessionStorage.setItem("programId", firmId);
    }
  }, [firmId, firmMap]);

  useEffect(() => {
    setFirmMap(firmMap);
    setFirmsData(firmsData);
    // Store the detected domain from server so client can use it
    if (detectedDomain) {
      setDetectedDomain(detectedDomain);
    }
  }, [firmMap, firmsData, detectedDomain]);

  return (
    <ReactQueryClientProvider>
      {/*
        Impersonation engine. Mounted here — inside the React Query provider it
        depends on (useQueryClient), and above BOTH the dashboard and the
        /login/callback flows that trigger impersonation — so useImpersonation()
        is available app-wide.

        enforce={false} for Phase 1: the permission policy still powers
        canImpersonate() for UI gating, but disallowed impersonate() calls are NOT
        blocked, so behavior matches today exactly with no actor-resolution timing
        regressions. Flip to enforce when the policy is finalized.
      */}
      <ImpersonationProvider enforce={false}>
        <Suspense>{children}</Suspense>
        <Toaster position="bottom-left" richColors />
      </ImpersonationProvider>
    </ReactQueryClientProvider>
  );
}
